import SectionBlock from '../components/c-section-block';
export default SectionBlock;
